import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Phone, Mail, Download, Menu, X } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const Header = () => {
  const { getCartCount } = useCart();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const cartCount = getCartCount();

  return (
    <header className="header-gradient sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        {/* Top bar with contact info */}
        <div className="hidden md:flex items-center justify-end py-2 text-sm text-white/90 border-b border-white/10">
          <div className="flex items-center gap-6">
            <a href="tel:+91 8849353962" className="flex items-center gap-2 hover:text-white transition-colors">
              <Phone size={14} />
              <span>+91 8849353962</span>
            </a>
            <a href="mailto:help@rentzoservices.com" className="flex items-center gap-2 hover:text-white transition-colors">
              <Mail size={14} />
              <span>help@rentzoservices.com</span>
            </a>
            <button className="flex items-center gap-2 px-4 py-1 bg-white/20 rounded-full hover:bg-white/30 transition-all">
              <Download size={14} />
              <span>Download App</span>
            </button>
          </div>
        </div>

        {/* Main navigation */}
        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="text-2xl md:text-3xl font-bold text-white">
              Rentzo <span className="text-white/80 font-light">Services</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-white hover:text-white/80 transition-colors font-medium">
              Home
            </Link>
            <Link to="/car" className="text-white hover:text-white/80 transition-colors font-medium">
              Car Rental
            </Link>
            <Link to="/bike" className="text-white hover:text-white/80 transition-colors font-medium">
              Bike Rental
            </Link>
          /*  <Link to="/appliance" className="text-white hover:text-white/80 transition-colors font-medium">
              Appliances
            </Link>
            <Link to="/pg" className="text-white hover:text-white/80 transition-colors font-medium">
              PG/Accommodation
            </Link> */
            <button
              onClick={() => navigate('/cart')}
              className="relative flex items-center gap-2 px-4 py-2 bg-white text-primary rounded-lg hover:bg-white/90 transition-all font-medium"
            >
              <ShoppingCart size={20} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-6 h-6 rounded-full flex items-center justify-center font-bold">
                  {cartCount}
                </span>
              )}
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2">
            <Link
              to="/"
              className="block py-2 px-4 text-white hover:bg-white/10 rounded transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/car"
              className="block py-2 px-4 text-white hover:bg-white/10 rounded transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Car Rental
            </Link>
            <Link
              to="/bike"
              className="block py-2 px-4 text-white hover:bg-white/10 rounded transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Bike Rental
            </Link>
         /*   <Link
              to="/appliance"
              className="block py-2 px-4 text-white hover:bg-white/10 rounded transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Appliances
            </Link>
            <Link
              to="/pg"
              className="block py-2 px-4 text-white hover:bg-white/10 rounded transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              PG/Accommodation
            </Link> */
            <button
              onClick={() => {
                navigate('/cart');
                setMobileMenuOpen(false);
              }}
              className="w-full flex items-center justify-center gap-2 py-2 px-4 bg-white text-primary rounded-lg hover:bg-white/90 transition-all font-medium relative"
            >
              <ShoppingCart size={20} />
              Cart
              {cartCount > 0 && (
                <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold">
                  {cartCount}
                </span>
              )}
            </button>
            <div className="flex flex-col gap-2 pt-2 border-t border-white/10">
              <a href="tel:+91 8849353962" className="flex items-center gap-2 py-2 px-4 text-white hover:bg-white/10 rounded">
                <Phone size={16} />
                <span>+91 8849353962</span>
              </a>
              <button className="flex items-center gap-2 py-2 px-4 bg-white/20 rounded hover:bg-white/30 text-white">
                <Download size={16} />
                <span>Download App</span>
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
